import React, { Fragment } from "react"
import PropTypes from "prop-types"
import styled from "react-emotion"

import Attribute from "features/records/components/Attribute"
import { Text, Container } from "ui"

class AttributeForm extends React.Component {
    state = {
        value: {},
    }

    constructor(props) {
        super(props)
        this.state.value = props.defaultState || {}
    }
    componentWillReceiveProps = ({ defaultState }) => {
        if (defaultState) {
            if (defaultState !== this.props.defaultState) this.setState({ value: defaultState })
        }
    }

    render() {
        const fields = this.props.fields
            .filter(field => !field.displayIf || field.displayIf(this.state.value))
            .map((field, i) => (
                <Container margin="small">
                    <FieldLabel>{field.label}</FieldLabel>
                    <Attribute
                        key={i}
                        onChange={val => this.updateValue(field.api_name, val)}
                        field={field}
                        editable
                    >
                        {this.state.value[field.api_name]}
                    </Attribute>
                </Container>
            ))

        return <Fragment>{fields}</Fragment>
    }

    updateValue(api_name, val) {
        const newVal = { ...this.state.value, [api_name]: val }
        if (this.props.onChange) this.props.onChange(newVal)
        this.setState({ value: newVal })
    }
}

AttributeForm.propTypes = {
    fields: PropTypes.arrayOf(PropTypes.object),
    data: PropTypes.object,
    onChange: PropTypes.func,
}

export default AttributeForm

const FieldLabel = styled(Text)`
    font-weight: bold;

    flex-basis: 30%;
    text-align: right;
    margin: 0px;
    padding-right: 30px;
    min-width: 80px;

    & + * {
        flex-grow: 1;
        max-width: 400px;
        @media screen and (max-width: 768px) {
            max-width: 120px;
        }
    }
`

// const FieldInput = styled(Input)`

// flex-grow: 1;
// max-width: 400px;
// `



// WEBPACK FOOTER //
// ./src/features/records/components/AttributesForm.js